<template>
	<v-container fluid pa-0 dark flat>
		<v-layout row wrap class="inner-container" justify-center mx-auto>
			<v-container px-0 py-3 flat>
				<v-stepper v-model="e1">
					<v-stepper-header>
						<v-stepper-step 
							:complete="stepValidation.first"
							:rules="[() => { return this.tryChange.first ? stepValidation.first : true }]"
							step="1" 
							complete-icon="fas fa-check subheading" 
							edit-icon="fas fa-check subheading" 
							error-icon="fas fa-exclamation-triangle subheading" 
							color="#1f97b9"
							editable
						>Datos Generales</v-stepper-step>
						<v-divider></v-divider>
						<v-stepper-step 
							:complete="stepValidation.second"
							:rules="[() => { return this.tryChange.second ? stepValidation.second : true }]"
							step="2" 
							complete-icon="fas fa-check subheading" 
							edit-icon="fas fa-check subheading" 
							error-icon="fas fa-exclamation-triangle subheading"
							color="#1f97b9"
							:editable="stepValidation.first"
						>Inventario</v-stepper-step>
						<v-divider></v-divider>
						<v-stepper-step 
							:complete="stepValidation.third"
							:rules="[() => { return this.tryChange.third ? stepValidation.third : true }]"
							step="3" 
							complete-icon="fas fa-check subheading" 
							edit-icon="fas fa-check subheading" 
							error-icon="fas fa-exclamation-triangle subheading"
							color="#1f97b9"
							:editable="stepValidation.second"
							@click="validateRequest('third')"
						>Presupuesto Básico</v-stepper-step>
					</v-stepper-header>
					<v-stepper-items>

						<v-stepper-content step="1">
							<v-alert
								v-if="userLogged"
								:value="alert"
								type="info"
								icon="fas fa-info-circle"
								transition="scale-transition"
							>
								Te recomendamos crear una cuenta antes de realizar tu pedido. 
								<v-btn
									color="primary"
									dark
									@click="openRegister"
								>
									Crea tu Cuenta
								</v-btn>
								<v-btn
									color="primary"
									dark
									@click="openLogin"
								>
									Ingresa a tu Cuenta
								</v-btn>
							</v-alert>
							<First/>
						</v-stepper-content>

						<v-stepper-content step="2">
							<Second/>
						</v-stepper-content>

						<v-stepper-content step="3">
							<Third/>
						</v-stepper-content>

					</v-stepper-items>
				</v-stepper>
			</v-container>
		</v-layout>

	  </v-layout>

    <v-snackbar
      :value="showMessage"
      :color="colorSnackbar"
      right
      top
    >
      {{ messageSnackbar }}
      <v-btn
        dark
        flat
        @click="showMessage = false"
      >
        Cerrar
      </v-btn>
    </v-snackbar>

	</v-container>
</template>

<script>
	import { EventBus } from '../../events.js'
	import First from './Fletes/First'
	import Second from './Fletes/Second'
	import Third from './Fletes/Third'
	import * as distance from 'google-distance-matrix'
	import * as firebase from 'firebase/app'
	import 'firebase/auth'
	import 'firebase/firestore'
	import 'firebase/functions'

	export default {
		name: 'FormFlete',
		components: {
			First,
			Second,
			Third
		},
		data () {
			return {
				e1: 2,
				selectedPayment: 1,
				mantenedores: {},
				datos: {
					first: {},
					second: {},
					third: {},
					baseValue: 0
				},
				tryChange: {
					first: false,
					second: false,
					third: false
				},
				stepValidation: {
					first: false,
					second: false,
					third: false
				},
				alert: true,
				userLogged: false,
				pedidoID: '',
				dialogPago: false,
				paymentValue: 0,
				toPayValue: 0,
				showCompleto: false,
				paymentData: {},
				tipo: "Mudanza",
				loadingPay: false,
				showMessage: false,
				colorSnackbar: 'info',
				messageSnackbar: '',
				dialogMW: '70%',
				controlSavedPedido: false,
				horas: ['00','01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23'],
				minutos: ['00','01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31','32','33','34','35','36','37','38','39','40','41','42','43','44','45','46','47','48','49','50','51','52','53','54','55','56','57','58','59'],
				time_diff: 0,
				date: '',
				time: '',
				today: new Date().toISOString().substr(0, 10),
				rules: {
					nameRules: [
						v => !!v || 'Campo obligatorio'
					]
				},
				showTooltip: false,
				typeTooltip: 'warning',
				menu: false,
				abonoMessage: '',
				dialogPagoCompleto: false,
				paymentInfo: {
					id: '',
					monto: 0,
					fecha: '',
					forma_pago: ''
				},
				colorTooltipActivator: '#1f97b9'
			}
		},
		methods: {
			validateRequest(step){
				if(step == 'third' && this.stepValidation.second){ EventBus.$emit('validateBeforeThirdFlete') }
			},
			get_mantenedores(){
				let db = firebase.firestore()
				let self = this
				db.collection("mantenedores").doc("mantenedores").get().then(function(doc) {
						if (doc.exists) {
								self.mantenedores = doc.data()
								EventBus.$emit('emmitMantenedores', self.mantenedores);
						} else {
								// doc.data() will be undefined in this case
								console.log("No such document!");
						}
				}).catch(function(error) {
						console.log("Error getting document:", error);
				});

			},
			save_data(data){
				//Guarda información del pedido en la BD, en espera de pago (Para pedido básico y completo)
				const user = firebase.auth().currentUser
				if(!user){
					let accountData = data.first.personales
					accountData.password = this.randomStr()
					//this.$auth.createAccount(accountData)
				}
				const pedido = {
					usuario: data.first.personales,
					direcciones: {
						origen: data.first.direccion_origen.direccion,
						destino: data.first.direccion_destino.direccion
					},
					elementos: data.second,
					fecha: this.$moment().format("YYYY-MM-DD"),
					hora: this.$moment().format("HH:mm"),
					datosDireccion: {
						origen: {},
						destino: {}
					},
					datoPagos: [],
					basicoValue: data.basicoValue,
					completoValue: data.completoValue,
					created: firebase.firestore.FieldValue.serverTimestamp(),
					estado: 'Cotización',
					servicio: data.servicio,
					paymentValue: 0,
					tipo: this.datos.tipo,
					distancia: this.datos.first.distancia,
					cargos: [],
					descuentos: [],
					observaciones: data.observaciones
				}
				let db = firebase.firestore()
				const here = this
				if(this.pedidoID != ''){
					db.collection("fletes").doc(this.pedidoID).set(pedido)
						.then(function() {
						})
						.catch(function(error) {
						    console.error("Error writing document: ", error);
						});
				}
				else{
					db.collection("fletes").add(pedido)
						.then(function(docRef) {
						    here.pedidoID = docRef.id
						})
			    db.collection('system_info').doc('pedidos').update({
			        qty_fletes: firebase.firestore.FieldValue.increment(1)
			    })
				}
			},
			openRegister(){
				this.alert = false
				EventBus.$emit('openRegister', true);				
			},
			openLogin(){
				this.alert = false
				EventBus.$emit('openLogin', true);				
			},
			randomStr() {
				var text = "";
				var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

				for (var i = 0; i < 8; i++)
					text += possible.charAt(Math.floor(Math.random() * possible.length));

				return text;
			},
			async getUser() {
				let user = await firebase.auth().currentUser;
				return user
			},
			getDistanceMatrix(){
				const here = this
				var service = new google.maps.DistanceMatrixService()
				service.getDistanceMatrix(
				  {
				    origins: [this.datos.first.direccion_origen.direccion],
				    destinations: [this.datos.first.direccion_destino.direccion],
				    travelMode: 'DRIVING'
				  },
				  function (response, status) {
						here.datos.first.distancia = response.rows[0].elements[0]
					}
				)
			},
		},
		watch: {
			e1: function(val){
				EventBus.$emit('stepChange', val)
			}
		},
		mounted(){
			const here = this
			setTimeout(function() {
				here.alert = false
			}, 10000);
			this.get_mantenedores()
			this.getUser()

			EventBus.$on('goBackFlete', data => {
				this.e1 = data - 1
				window.scrollTo(0,0)
			})
			EventBus.$on('fleteFirst', data => {
				this.tryChange.first = true
				this.stepValidation.first = data.valid
				if(data.valid){
					this.datos.first = data.datos
					this.getDistanceMatrix()
					this.e1 = 2
					this.tryChange.first = false
					window.scrollTo(0,0)
				}
			})
			EventBus.$on('fleteSecond', data => {
				this.tryChange.second = true
				this.stepValidation.second = data.valid
				if(data.valid){
					this.datos.second = data.datos
					this.datos.tipo = "Flete"
					this.datos.observaciones = data.observaciones
					this.e1 = 3
					this.tryChange.second = false
					EventBus.$emit('enterFleteThird', this.datos)
					this.controlSavedPedido = false
					window.scrollTo(0,0)
				}
			})
			EventBus.$on('finalFleteValue', data => {
				console.log(data)
				if(!this.controlSavedPedido){
					this.save_data(data)
				}
				this.controlSavedPedido = true
			})

		}
	}
</script>